import React, { useState, useEffect } from 'react';

import { DatanomikIso } from '@/views/common/Logo';
import { cn, ProgressBar, Text } from '@datanomik/core-ui';
interface LoadingPageNewProps {
  leaving?: any;
  message?: any;
  footer?: any;
}

export const LoadingPageNew = ({ leaving = false, message, footer }: LoadingPageNewProps) => {
  const [exitStarted, setExitStarted] = useState(false);

  useEffect(() => {
    if (!leaving) return undefined;
    const id = requestAnimationFrame(() => setExitStarted(true));
    return () => cancelAnimationFrame(id);
  }, [leaving]);

  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background/70 backdrop-blur-xl transition-opacity duration-200 ease-out',
        exitStarted ? 'pointer-events-none opacity-0' : 'opacity-100',
      )}
    >
      <div className="animate-breathe mb-8 text-primary">
        <DatanomikIso className="size-11" />
      </div>

      <div className="w-[160px]">
        <ProgressBar size="xs" />
      </div>

      {message && (
        <Text variant="body-sm" weight="medium" tone="muted" className="mt-6">
          {message}
        </Text>
      )}

      {footer && (
        <div className="absolute inset-x-0 bottom-12 text-center">
          {footer}
        </div>
      )}
    </div>
  );
};
